import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Tab } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar';
import AddAnswer from '../../components/teacher/AddAnswer';
import AnswerCategories from '../../components/teacher/AnswerCategories';

export default function TeacherAnswer() {
    const {t} = useTranslation()
    const [value, setValue] = React.useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Navbar>
            <TabContext value={value} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider',marginTop:"100px" }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label={t('View Answers')} value="1" />
                        <Tab label={t('Add New Answer')} value="2" />
                    </TabList>
                </Box>
                    <TabPanel value="1"><AnswerCategories /></TabPanel>
                    <TabPanel value="2"><AddAnswer /></TabPanel>
                </TabContext>
        </Navbar>
    )
}